import { Component, OnInit }          from '@angular/core';
import { Router }                     from '@angular/router';

import { RouteOptions }               from '../models/route-options';
import { SubscriptionsService }       from './subscriptions.service';
import { Subscription }               from './models/subscription';
import { SubscriptionFilters }        from './models/subscription-filters';

import { PermissionsService }         from '../shared/services/permissions.service';
import { AllPermissions }             from '../models/permissions';

@Component({
  selector: 'app-subscription-list',
  templateUrl: './subscription-list.component.html',
  styleUrls: ['./subscription-list.component.less']
})
export class SubscriptionListComponent implements OnInit {
  public subs: Subscription[] = null;
  public checkedSubs: Subscription[] = [];
  public filters: SubscriptionFilters = {
    search: '',
    buyer_type: 'admin'
  };
  public canLoadMore: boolean = false;
  private subscriptionName: string;
  private loadTimeout = null;
  public permissions: AllPermissions;

  constructor(private api: SubscriptionsService, private router: Router, private permissionsService: PermissionsService) {
    this.loadSubs();
    permissionsService.retrievePermissions().subscribe(permissions => {
      this.permissions = permissions;
    });
  }

  ngOnInit() {
  }

  public selectSub(sub: Subscription, event) {
    if (this.permissions.manageSubscriptions || this.permissions.manageSubscriptionUsers) {
      this.openManagement(sub, event);
    }
    else {
      this.openAnalytics(sub, event);
    }
  }

  public openManagement(sub: Subscription, event) {
    // If full subscription management, default to settings, otherwise users
    event.stopPropagation();
    if (this.permissions.manageSubscriptions) {
      this.router.navigate(['subscriptions', sub.id]);
    } else {
      this.router.navigate(['subscriptions', sub.id, 'users']);
    }
  }

  public openAnalytics(sub: Subscription, event) {
    event.stopPropagation();
    this.router.navigate(["/analytics/subscriptions", sub.id, "users"]);
  }

  public handleFilterChange() {
    if (this.loadTimeout) {
      window.clearTimeout(this.loadTimeout);
    }
    window.setTimeout(() => {
      this.loadSubs();
      this.loadTimeout = null;
    }, 500);
  }

  public loadMore() {
    if (this.subs && this.subs.length) {
      let lastSubId = this.subs[this.subs.length - 1].id;
      this.api.getSubscriptions(this.filters, lastSubId).subscribe(subscriptions => {
        subscriptions.forEach(sub => this.subs.push(sub));
        this.canLoadMore = subscriptions.length == 25;
      });
    }
  }

  private loadSubs(): void {
    this.api.getSubscriptions(this.filters).subscribe(subscriptions => {
      this.subs = subscriptions;
      this.canLoadMore = subscriptions.length == 25;
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/subscriptions/subscription-list.component.ts